export default __webpack_public_path__ + "static/19-fc1d9a02d7021730fef2a9e56f682f22.jpg";